import { GTM_EVENT_CATEGORY } from '@/lib/tracking/types/GTM_EVENT_CATEGORY'

export const SECTION_REQUIRED_CATEGORIES = new Set([
  GTM_EVENT_CATEGORY.DONATION,
  GTM_EVENT_CATEGORY.VENDOR_CLICK,
])

export const GTM_CONFIG = {
  [GTM_EVENT_CATEGORY.DONATION]: {
    event: 'donaButton',
    eventName: `dona_ora_gdr`,
  },

  [GTM_EVENT_CATEGORY.HERO_DONATION]: {
    event: 'sostieniRicercaBtn',
    eventName: `sostieni_gdr`,
  },

  [GTM_EVENT_CATEGORY.NEWSLETTER]: {
    event: 'newsletter',
    eventName: `newslettersignup_gdr`,
  },

  [GTM_EVENT_CATEGORY.QUERY_LOCATION]: {
    event: 'ricercaPiazza',
    eventName: 'ricerca_piazza_cioccolatini',
  },

  // TODO support multiple vendors
  [GTM_EVENT_CATEGORY.VENDOR_CLICK]: {
    event: 'amazonButton',
    eventName: 'goto_amazon',
  },

  [GTM_EVENT_CATEGORY.DISTRIBUTION]: {
    event: 'puntiDistribuzione',
    eventName: 'punto_distribuzione',
    buttonName: 'punti di distribuzione',
  },

  [GTM_EVENT_CATEGORY.LOCATION_ACTIONS]: {
    event: `ricercaInsights`,
    eventName: `ricerca_piazza_cioccolatini`,
  },

  [GTM_EVENT_CATEGORY.EVENT_CLICKTHROUGH]: {
    event: `initiativeBtn`,
    eventName: `evento_gdr`,
  },

  [GTM_EVENT_CATEGORY.PARTNER_CLICKTHROUGH]: {
    event: 'extBtn',
    eventName: 'partner_clicked_igr',
  },

  [GTM_EVENT_CATEGORY.SUPPORT_US]: {
    event: 'sostieniRicercaBtn',
    eventName: 'sostieni_igr',
  },
} as const
